import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./login.component";
import { ForgotComponent } from "./forgot.component";
import { SignupComponent } from "./signup.component";

const routes: Routes = [
  {
    path: "",
    data: {
      title: "Example Pages",
    },
    children: [
      {
        path: "login",
        component: LoginComponent,
        data: {
          title: "Login Page",
        },
      },
      {
        path: "forgot-password",
        component: ForgotComponent,
        data: {
          title: "Forgot Password?",
        },
      },
      {
        path: "signup/:token",
        component: SignupComponent,
        data: {
          title: "Sign Up",
        },
      },
      {
        path: "reset-password/:token",
        component: SignupComponent,
        data: {
          title: "Reset Password",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
